import React from "react";
import { cn } from "../../lib/utils";

const SizeSelector = ({ sizes, value, onChange, error }) => (
  <div>
    <div className="flex flex-wrap gap-2" data-testid="size-selector">
      {sizes.map((size) => {
        const active = value === size;
        return (
          <button
            key={size}
            onClick={() => onChange(size)}
            aria-pressed={active}
            data-testid={`size-option-${size}`}
            className={cn(
              "flex h-11 min-w-[3rem] items-center justify-center border px-2 font-mono text-sm uppercase transition-colors duration-150",
              active
                ? "border-ink bg-ink text-paper"
                : "border-ink/25 text-ink hover:border-ink"
            )}
          >
            {size}
          </button>
        );
      })}
    </div>
    {error && (
      <p className="mt-2 font-mono text-xs text-red-600" data-testid="size-error">
        {error}
      </p>
    )}
  </div>
);

export default SizeSelector;
